import PersonaPage from "./PersonaPage";
import { questionsPersonFemale } from "./questions";

const faq = [
  {
    q: "Wie schreibt man eine Trauerrede für die Tochter?",
    a: "Es gibt kein Skript für Eltern, die ihr Kind verabschieden. Alles was tragen kann, ist das Konkrete: ein Bild, ein Ritual, ein Satz. Wir helfen, dieses Bild zu finden — und drumherum eine Rede, die gehalten werden kann.",
  },
  {
    q: "Wie kurz darf eine Trauerrede für die Tochter sein?",
    a: "So kurz, wie Sie es aushalten. Eine Rede von einer Minute, in der ein einziges, klares Bild steht, ist würdiger als zwanzig Minuten allgemeiner Worte.",
  },
  {
    q: "Was, wenn ich es an dem Tag nicht schaffe zu sprechen?",
    a: "Verständlich. Viele Angehörige lassen die Rede in solchen Fällen vortragen — von einem Geschwisterkind, einer engen Freundin, einem Trauerredner. Der Entwurf funktioniert auch aus einem anderen Mund würdig.",
  },
  {
    q: "Sollen wir sie in der Rede beim Vornamen nennen?",
    a: "Ja, in aller Regel. „Unsere Tochter Anna“ ist würdiger und wärmer als „das Kind“. Wir setzen den Namen behutsam ein.",
  },
  {
    q: "Wie schnell erhalten wir den Entwurf?",
    a: "Sofort nach Zahlung. Der Entwurf erscheint auf dem Bildschirm, als PDF und zusätzlich per E-Mail — meist in unter zwei Minuten.",
  },
];

const related = [
  { label: "Trauerrede für den Sohn", to: "/trauerrede-sohn" },
  { label: "Trauerrede für die Schwester", to: "/trauerrede-schwester" },
  { label: "Trauerrede schreiben — Anleitung", to: "/trauerrede-schreiben" },
];

export default function TrauerredeTochter() {
  return (
    <PersonaPage
      slug="trauerrede-tochter"
      metaTitle="Trauerrede für die Tochter schreiben — behutsam & würdevoll | Oratiorede"
      metaDescription="Eine persönliche Trauerrede für die Tochter. Aus acht behutsamen Fragen entsteht ein würdevoller Entwurf — auch wenn Worte gerade unmöglich scheinen. Ab 29 €."
      eyebrow="Trauerrede · Tochter"
      headline={
        <>
          Eine Trauerrede für die Tochter.
          <br />
          <span className="italic text-umber">Behutsam. Klein genug, um getragen zu werden.</span>
        </>
      }
      intro="Es gibt keine Rede, die das aushalten muss. Aber es gibt eine, die getragen werden kann. Aus einem Bild, einem Satz, einer Erinnerung — ein Rahmen, in dem der Name Ihrer Tochter würdevoll ausgesprochen werden darf."
      heroImage="https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=1920&q=80"
      heroImageAlt="Ein Fenster im Morgenlicht mit einem weißen Vorhang — stille Zurückhaltung als Sinnbild einer Trauerrede für die Tochter"
      questions={questionsPersonFemale}
      exampleQuote={
        <>
          „Was wir an ihr geliebt haben, war die Art, mit der sie einen Raum betrat: leise,
          aufmerksam, als wollte sie zuerst prüfen, ob es allen anderen gut geht. Sie hat sich
          nie in den Vordergrund gedrängt — und trotzdem war sie in jedem Raum die, an die man
          sich später am deutlichsten erinnert. So werden wir sie behalten.“
        </>
      }
      faq={faq}
      related={related}
    />
  );
}
